module.exports = __webpack_public_path__ + "static/media/sold.8561981e.svg";